import { createEvent } from 'effector';

export const setProjectsMapStartDataEv = createEvent();

export const resetProjectsMapFilteredStoreEv = createEvent();
